<template>
  <div class="container-fluid">
    <div class="row">
      <button
        type="button"
        class="btn btn-primary btn-voltar"
        @click="$router.back()"
      >
        <font-awesome-icon :icon="'arrow-left'" />
        Voltar
      </button>
      <h1 class="page-header">
        {{ dadoNome }}
      </h1>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12">
            <div :class="['form-group', { 'has-error': errors.has('data') }]">
              <label class="control-label custom-font">Data</label>
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon :icon="'calendar'"></font-awesome-icon>
                  </span>
                  <!-- <input ref="data" @keyup.enter="setFocus('valor')" v-model="modelData" name="data" placeholder='Data' class='form-control' v-validate="'required'" type='date'> -->
                  <datepicker
                    v-model="modelData"
                    name="data"
                    ref="data"
                    v-validate="'required'"
                  ></datepicker>
                </div>
                <small
                  v-if="errors.has('data')"
                  data-bv-validator="notempty"
                  data-bv-validator-for="data"
                  class="help-block"
                  style=""
                  >{{ errors.first('data') }}</small
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12" v-if="isValueInteiro || isValueDecimal">
          <div class="col-xs-12 col-sm-3">
            <div :class="['form-group', { 'has-error': errors.has('valor') }]">
              <label class="control-label">Valor</label>
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon :icon="'chart-bar'"></font-awesome-icon>
                  </span>
                  <input
                    ref="valor"
                    @keyup.enter="save()"
                    v-if="isValueInteiro"
                    name="valor"
                    v-model="modelValue"
                    class="form-control"
                    v-validate="{
                      required: true,
                      regex: /^[\+|\-]?[0-9]+$/
                    }"
                    type="text"
                  />
                  <money
                    ref="valor"
                    @keyup.enter="save()"
                    v-if="isValueDecimal"
                    name="valor"
                    v-model="modelValue"
                    class="form-control"
                    v-validate="'required'"
                    v-bind="configMoney()"
                  />
                </div>
                <small
                  v-if="errors.has('valor')"
                  data-bv-validator="notempty"
                  data-bv-validator-for="valor"
                  class="help-block"
                  style=""
                  >{{ errors.first('valor') }}</small
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12" v-if="isValueTexto">
          <div class="col-xs-12">
            <div
              :class="['form-group', { 'has-error': errors.has('resposta') }]"
            >
              <label class="control-label">Resposta</label>
              <textarea
                ref="resposta"
                @keyup.enter="save()"
                name="resposta"
                v-model="modelValue"
                class="form-control"
                v-validate="'required'"
                rows="7"
              ></textarea>
              <small
                v-if="errors.has('resposta')"
                data-bv-validator="notempty"
                data-bv-validator-for="resposta"
                class="help-block"
                style=""
                >{{ errors.first('resposta') }}</small
              >
            </div>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="col-xs-12">
            <div class="form-group">
              <label class="control-label custom-font">Observação</label>
              <textarea
                ref="observacao"
                rows="7"
                name="observacao"
                v-model="modelObservacao"
                placeholder="Digite aqui sua observação..."
                class="form-control"
              >
              </textarea>
            </div>
          </div>
        </div>

        <div class="col-xs-12">
          <!-- button -->
          <div class="form-group" style="margin-top: 30px">
            <div>
              <button
                @click.prevent="save()"
                class="btn btn-default"
                :disabled="carregando"
              >
                <font-awesome-icon v-if="carregando" :icon="'spinner'" spin />
                <font-awesome-icon v-else :icon="'save'" />
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { request } from '@/request'
import datepicker from '@/components/common/Datepicker'

export default {
  name: 'dados-valor-save',
  components: { datepicker },
  data() {
    return {
      carregando: false,
      title: 'valor',
      dadoTipo: '',
      dadoNome: 'Carregando o nome do dado...',
      dadoPeriodicidade: '',
      modelData: '',
      modelValue: '',
      modelId: '',
      modelDadoId: '',
      modelObservacao: ''
    }
  },
  computed: {
    type: function() {
      return this.isUpdate ? 'Editar' : 'Adicionar'
    },
    dateFormat: function() {
      if (!this.modelData) return null
      return `${this.modelData.getFullYear()}-${this.modelData.getMonth() +
        1}-${this.modelData.getDate()}`
    },
    model: function() {
      var m = {
        DAD_IDDADO: this.modelDadoId,
        DVA_DTDADOVALOR: this.dateFormat,
        DVA_DLOBSERVACAO: this.modelObservacao,
        DVA_IDDADOVALOR: this.modelId
      }

      if (this.isValueInteiro || this.isValueDecimal) {
        m.DVA_VLDADOVALOR = this.modelValue
      } else {
        m.DVA_DLDADOVALOR = this.modelValue
      }

      return m
    },
    isUpdate() {
      return !!this.$router.currentRoute.params.DVA_IDDADOVALOR
    },
    isValueInteiro() {
      if (this.dadoTipo) {
        return this.dadoTipo === 'I'
      }
      return false
    },
    isValueDecimal() {
      if (this.dadoTipo) {
        return this.dadoTipo === 'D'
      }
      return false
    },
    isValueTexto() {
      if (this.dadoTipo) {
        return this.dadoTipo === 'T'
      }
      return false
    }
  },
  watch: {
    modelValue(val, old) {
      if (this.isValueInteiro) {
        if (isNaN(val) && val !== '-') {
          this.modelValue = old
        }
      }
    }
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  created() {
    this.loadDado()

    if (this.isUpdate) {
      this.loadValue()
    }
  },
  mounted() {
    var r = this.$refs
    if (this.isUpdate) {
      setTimeout(() => {
        if (this.isValueDecimal || this.isValueInteiro) {
          if (this.isValueDecimal) {
            r.valor.$el.focus()
          } else {
            r.valor.focus()
          }
        } else {
          r.resposta.focus()
        }
      }, 500)
    }
  },
  methods: {
    handleLoading() {
      this.carregando = !this.carregando
    },
    loadDado() {
      const { DAD_IDDADO } = this.$router.currentRoute.params
      this.handleLoading()
      request
        .get(`dado/get/${DAD_IDDADO}`)
        .then(response => this.setDado(response.data))
        .catch(error => console.log(error))
        .finally(this.handleLoading)
    },
    setDado({ codigo, tipoValor, nome, periodicidade }) {
      this.modelDadoId = codigo
      this.dadoTipo = tipoValor
      this.dadoNome = nome
      this.dadoPeriodicidade = periodicidade.descricao

      if (!this.isUpdate) this.setDateDefault()
    },
    setDateDefault() {
      const now = new Date()
      let month, periodoNumber

      if (this.dadoPeriodicidade.toLowerCase() === 'anual')
        this.modelData = new Date(now.getFullYear() - 1, 11, 31)
      else {
        switch (this.dadoPeriodicidade.toLowerCase()) {
          case 'semestral':
            periodoNumber = 6
            break
          case 'quadrimestral':
            periodoNumber = 4
            break
          case 'trimestral':
            periodoNumber = 3
            break
          case 'bimestral':
            periodoNumber = 2
            break
          case 'mensal':
            periodoNumber = 1
            break
        }

        const periodoAtual =
          periodoNumber > 1
            ? Math.floor((now.getMonth() + 1) / periodoNumber)
            : now.getMonth()

        if (periodoAtual === 0)
          this.modelData = new Date(now.getFullYear() - 1, 11, 31)
        else {
          month = periodoNumber * periodoAtual
          const date = new Date(now.getFullYear(), month, 1)
          date.setDate(date.getDate() - 1)
          this.modelData = date
        }
      }
    },
    loadValue() {
      const { DVA_IDDADOVALOR } = this.$router.history.current.params
      this.handleLoading()
      request
        .post('dado/valor/get', { DVA_IDDADOVALOR })
        .then(({ data }) => {
          this.setValue(data.data)
        })
        .catch(error => {
          // console.log(error.response)
          this.$toastr.e(
            'Houve um erro no carregamento das informações, tente novamente.'
          )
        })
        .finally(this.handleLoading)
    },
    setValue(data) {
      const {
        DVA_IDDADOVALOR,
        DVA_DTDADOVALOR,
        DVA_VLDADOVALOR,
        DVA_DLDADOVALOR,
        DVA_DLOBSERVACAO,
        dado
        // isValueInteiro,
        // isValueDecimal
      } = data

      this.modelId = DVA_IDDADOVALOR
      this.modelData = new Date(DVA_DTDADOVALOR)

      this.modelDadoId = dado.DAD_IDDADO
      this.dadoTipo = dado.DAD_CDTIPOVALOR
      this.dadoNome = dado.DAD_DCNOME

      if (this.dadoTipo === 'D' || this.dadoTipo === 'I') {
        this.modelValue = this.dadoTipo
          ? parseInt(DVA_VLDADOVALOR)
          : parseFloat(DVA_VLDADOVALOR)
      } else {
        this.modelValue = DVA_DLDADOVALOR
      }
      this.modelObservacao = DVA_DLOBSERVACAO === null ? '' : DVA_DLOBSERVACAO
    },
    getValueDefault() {
      return this.isValueInteiro || this.isValueDecimal ? 0 : ''
    },
    saveSuccess(result) {
      const { $toastr, $router } = this
      const { DAD_IDDADO } = this.$router.currentRoute.params

      $toastr.s('Valor foi salvo com sucesso.')

      $router.push({
        name: 'admin_dado_valor_list',
        params: { DAD_IDDADO }
      })
    },
    saveFail({ response }) {
      // this.$toastr.e(
      //   'Houve uma falha ao tentar salvar este item, Tente novamente daqui alguns minutos!'
      // )
      this.$toastr.e(response.data.msg)
    },
    save() {
      const { $validator, $refs, $toastr, model, saveSuccess, saveFail } = this

      $validator.validateAll().then(result => {
        if (!result) {
          $refs[$validator.errors.items[0].field].focus()
          $toastr.e($validator.errors.items[0].msg)
          return
        }

        this.handleLoading()
        request
          .post('dado/valor/save', model)
          .then(saveSuccess)
          .catch(saveFail)
          .finally(this.handleLoading)
      })
    },
    concatPathImage(file) {
      return this.$root.$data.imgUrl + file + '?' + new Date().getTime()
    },
    configMoney() {
      return {
        decimal: ',',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    },
    setFocus(input) {
      this.$refs[input].focus()
    }
  }
}
</script>

<style scoped>
.page-header {
  font-size: 2.8em !important;
}
.inputgroupcontainer {
  max-width: 250px;
}
.custom-font {
  color: #00615c;
  font-size: 16px;
}
.fa-calendar {
  color: #00615c;
}
.btn-voltar {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/dados/values/Save.vue